import React, { useEffect, useState } from "react";
import "./GeneralUserPage.css";
import FundraiserTabs from "../../../components/Dashboard/GeneralProfile/FundraiserTabDisplay";
import ProfileBanner from "../../../components/Dashboard/ProfileBanner";
import { getCurrentlyLoggedInUser } from "../../../CommonFunctions";
import config from "../../../config";
import { useNavigate } from "react-router-dom";
import FundraisersAwaitingCoordinator from "../../../components/Dashboard/FundraisersAwaitingCoordinator";
import EnterfundraiserID from "../../../pages/EnterFundraiserID";
import ActiveFundraisersForParticipantsTable from "../../../components/Dashboard/GeneralProfile/ActiveFundraisersForParticipants";

const GeneralUserPage = () => {
  const [accountID, setAccountID] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [loggedInAccount, setLoggedInAccount] = useState<{
    first_name: string;
    last_name: string;
    profile_pic: string;
    id: number;
  } | null>(null);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const user = await getCurrentlyLoggedInUser();
        setLoggedInAccount(user);
      } catch (error) {
        navigate("/login");
      }

      const token = localStorage.getItem("accessToken");

      if (!token) {
        setError("User is not authenticated");
        return;
      }

      try {
        const response = await fetch(
          `${config.API_BASE_URL}account/user-details/`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          setAccountID(data.account);
        } else {
          const errorData = await response.json();
          setError(errorData.detail || "Failed to fetch user details");
        }
      } catch (err) {
        setError("An error occurred. Please try again.");
      }
    };

    fetchUserDetails();
    document.title = "User Dashboard";
  }, []);

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (accountID === null) {
    return <div>Loading...</div>;
  }

  if (!loggedInAccount || accountID === null) {
    return <div>Loading...</div>;
  }

  return (
    <div className="general-user-dashboard-page-layout-container">
      <div className="general-user-dashboard-page-profile-banner">
        {loggedInAccount && (
          <ProfileBanner
            name={`${loggedInAccount.first_name} ${loggedInAccount.last_name}`}
            role="User"
            profile_pic={loggedInAccount.profile_pic}
          />
        )}
      </div>
      <div className="general-user-dashboard-page-main-content">
        {/*
      <div className="general-user-dashboard-page-quick-actions-sidebar">
          <QuickActionsSidebar />
        </div>
        */}
        <div className="general-user-dashboard-page-fundraiser-tabs">
          <ActiveFundraisersForParticipantsTable
            account_id={loggedInAccount.id}
          />
          <FundraisersAwaitingCoordinator user_id={loggedInAccount.id} />
          <FundraiserTabs accountID={loggedInAccount.id} />
          <EnterfundraiserID />
        </div>
      </div>
    </div>
  );
};

export default GeneralUserPage;
